import React from 'react';
import PropTypes from 'prop-types';

import style from './style.module.scss';

export function Heading() {
  return (
    <h3 className={style.heading}>Set the temperature on the heat block</h3>
  );
}

Heading.propTypes = {};
